import React from 'react';
import './SuccessPopup.css';
import errorImg from  '../assets/images/error.png';


function  ErrorWindow({onClose}) {


  return (
    <>
      <div className='overlay-success'>

        <div className="main-frame-success">

          <div className="text-content-title">
           <img src={errorImg} alt='Error' style={{ width: "70px", height: "70px" }}/>
            <p  style={{ color:"red", fontSize:"30px", marginTop:"20px", fontWeight:"500" }}>
              Unknown Error Occur......!
            </p>
          </div>
          <div className='finish-button-success' >
              <p className="div" onClick={onClose} style={{ backgroundColor:"red"}} >Close</p>
              {/* <p className="div" onClick={onClose}>Finished</p> */}
           
          </div>

        </div>

      </div>
    </>
  );
}

export default ErrorWindow;